import axiosInstance from "./axiosInstance";
import { BASE_URL } from "../constants/Constants";

export const getCellsByLibraryId = async (id) => {
    try {
        const response = await axiosInstance.get(`${BASE_URL}/cell/library/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching Cells by libraryId:', error);
        return error.response.data;
        //throw error;
    }
};

export const addCell = async (payload) => {
  try {
    const response = await axiosInstance.post(`${BASE_URL}/cell`, payload);
    return response.data;
  } catch (error) {
    console.error('Error creating cell:', error);
    return error.response.data;
    // throw error;
  }
};

export const updateCell = async (payload) => {
  try {
    const response = await axiosInstance.put(`${BASE_URL}/cell`, payload);
    return response.data;
  } catch (error) {
    const code = error.response?.data?.code;

    if (code === 'CELL_NAME_EXISTS') {
      throw new Error(code);
    }
    return error.response.data;
    //throw error;
  }
};

export const getCellById = async (id) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/cell/${id}`);
    return response.data;    
  } catch (error) {
    console.error('Error fetching Cell by id:', error);
    return error.response.data;
    //throw error;
  }
};

export const getCellsByLibIdAndViewType = async (libraryId, viewType) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/cell/library/${libraryId}/${viewType}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching Cells with views:', error);
    return error.response.data;
    //throw error;
  }
};

